import React from 'react'
import foods from "../../Assets/foods.png"
import ecommerce from "../../Assets/E-Commerce.png"
import payments from "../../Assets/Payment.png"
import media from "../../Assets/media.png"
import edtech from "../../Assets/Ed-tech.png"
import indusindbank from '../../Assets/indusindbank.png'
import fingpay from '../../Assets/fingpay.png'
import yesbank from "../../Assets/yesbnk.png"
import CtaSection from "../CtaSection/CtaSection"
import our_mission from "../../Assets/our_mission.webp"
import what_we_do from "../../Assets/what_we_do.webp"
import vision from "../../Assets/vision.webp"
import instant_pay from "../../Assets/instant_pay.webp";
import axis_bank from "../../Assets/axis_bank.webp";
import idfc_bank from "../../Assets/idfc_bank.webp";
import razorpay_logo_ from "../../Assets/razorpay_logo_.webp";



const partner = [
  {
    img: yesbank,
  },
  {
    img: indusindbank,
  },
  {
    img: fingpay,
  },
  {
    img: instant_pay,
  },
  {
    img: axis_bank,
  },
  {
    img: idfc_bank,
  },
  {
    img: razorpay_logo_,
  },
]


const aboutService = [
  {
    icon: foods,
    title: "foods",
  },
  {
    icon: ecommerce,
    title: "e-Commerce",
  },
  {
    icon: payments,
    title: "payment",
  },
  {
    icon: media,
    title: "media",
  },
  {
    icon: edtech,
    title: "Ed-tech",
  },
]

export default function About() {
  return (
    <div>
      <section className="relative bg-[#000856]  py-24 md:py-32 overflow-hidden font-inter">

        
        <div className="absolute inset-0 z-0">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/10 blur-[120px] rounded-full" />
          <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-pink-500/10 blur-[150px] rounded-full" />
         
          <div className="absolute inset-0 opacity-[0.03] [mask-image:radial-gradient(ellipse_at_center,white,transparent)]"
            style={{ backgroundImage: 'radial-gradient(#fff 1px, transparent 1px)', backgroundSize: '40px 40px' }} />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6">

        
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-20 gap-6">
            <div className="max-w-2xl">
              <h2 className="text-pink-500 font-bold tracking-[0.3em] uppercase text-sm mb-4">Our Core Expertise</h2>
              <h3 className="font-spacegrotesk text-white text-4xl md:text-6xl font-bold leading-tight">
                What <span className="text-transparent bg-clip-text bg-gradient-to-r from-white via-blue-200 to-pink-300">Bumppy</span> <br />
                actually does ?.
              </h3>
            </div>
            
          </div>

          
          <div className='grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 md:gap-8'>
            {aboutService.map((item, index) => (
              <div key={index} className="group relative">
               
                <div className="relative h-full flex flex-col items-center p-8 rounded-[2.5rem] bg-white/5 border border-white/10 backdrop-blur-sm transition-all duration-500 group-hover:-translate-y-3 group-hover:bg-white/10 group-hover:border-white/20">

                  
                  <div className="relative mb-8">
                    
                    <div className="absolute inset-0 bg-pink-500 blur-2xl opacity-0 group-hover:opacity-20 transition-opacity duration-500 rounded-full" />

                   
                    <div className='relative h-24 w-24 md:h-28 md:w-28 rounded-3xl  bg-white  flex items-center justify-center border border-white/10 transition-all duration-500 group-hover:rotate-[10deg] group-hover:rounded-full '>
                      <img
                        src={item.icon}
                        alt={item.title}
                        className="w-12 h-12 md:w-14 md:h-14 object-contain transition-all duration-500 group-hover:scale-110 group-hover:brightness-100"
                      
                     
                      />
                    </div>
                  </div>

                  
                  <h4 className="text-white text-center font-bold text-sm md:text-base tracking-widest uppercase mb-2 group-hover:text-pink-400 transition-colors">
                    {item.title}
                  </h4>

                 
                  <div className="w-8 h-1 bg-white/20 rounded-full group-hover:w-16 group-hover:bg-pink-500 transition-all duration-500" />

                  
                  <span className="absolute top-4 right-6 text-white/20 font-black text-4xl italic group-hover:text-white/10 transition-colors">
                    0{index + 1}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
        

       
      </section>
      <section className='py-16 md:py-24 overflow-hidden'>

        <header className="text-center max-w-3xl mx-auto mb-20">


          <h2 className="font-spacegrotesk text-slate-900 text-3xl sm:text-4xl md:text-5xl font-bold leading-tight">
            We Build <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">Smiles.</span>
          </h2>

          <div className="w-20 h-1.5 bg-pink-500 mx-auto mt-6 rounded-full" />

          <p className='text-slate-500 text-lg md:text-xl font-medium mt-6 leading-relaxed'>
            Bumppy Payments - One Source For All Your Payments.
          </p>
        </header>
        

       
        <section className="relative w-full py-24 lg:py-36 bg-gradient-to-bl from-[#041294] to-[#000856] overflow-hidden">

          
          <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-blue-600/10 blur-[120px] rounded-full" />
          <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-indigo-600/10 blur-[100px] rounded-full" />

          <div className="max-w-7xl mx-auto px-6 relative z-10">
            <div className="grid lg:grid-cols-12 gap-16 items-center">

              
              <div className="lg:col-span-7 space-y-10">
                <div className="space-y-6">
                  <h2 className="text-5xl md:text-7xl font-black text-white leading-[1.05] font-spacegrotesk tracking-tight">
                    Our <span className="text-transparent bg-clip-text bg-gradient-to-br from-blue-400 via-indigo-300 to-pink-400">Mission</span>
                  </h2>

                  <p className="text-slate-400 text-lg md:text-2xl leading-relaxed font-light max-w-2xl">
                    To create a massive payment system that uses technology to distribute payments instantly in a perfect networked environment. Provide customers convenient, straightforward ways to make payments anywhere, anytime. to provide rural Indians with simple access to last mile banking services and other financial goods.
                  </p>
                </div>

              

               
                <div className="relative pl-8 border-l-2 border-indigo-500/50">
                  <p className="text-xl md:text-2xl text-indigo-100 font-medium italic leading-snug">
                    "Providing rural Indians with simple access to last-mile banking services and other financial goods."
                  </p>
                  
                </div>
              </div>

              
              <div className="lg:col-span-5 relative">
                <div className="relative z-20 group">
                 
                  <div className="relative rounded-[3rem] p-3 bg-gradient-to-b from-white/10 to-transparent backdrop-blur-2xl border border-white/20 shadow-2xl transform transition-transform duration-1000 group-hover:rotate-1">
                    <img
                      src={our_mission}
                      alt="Bumppy Mission"
                      className="w-full h-auto rounded-[2.5rem] shadow-inner grayscale-[20%] group-hover:grayscale-0 transition-all duration-700"
                    />
                   
                  </div>

                
                  <div className="absolute -top-12 -left-12 w-24 h-24 border-t-2 border-l-2 border-blue-500/30 rounded-tl-3xl" />
                  <div className="absolute -bottom-12 -right-12 w-24 h-24 border-b-2 border-r-2 border-indigo-500/30 rounded-br-3xl" />
                </div>
              </div>

            </div>
          </div>
        </section>

        <section className="relative w-full py-24 lg:py-36  overflow-hidden">

          <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-blue-600/10 blur-[120px] rounded-full" />
          <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-indigo-600/10 blur-[100px] rounded-full" />

          <div className="max-w-7xl mx-auto px-6 relative z-10">
            <div className="grid lg:grid-cols-12 gap-16 items-center">  
              <div className="lg:col-span-5 relative">
                <div className="relative z-20 group">
                  
                  <div className="relative rounded-[3rem] p-3 bg-gradient-to-b from-white/10 to-transparent backdrop-blur-2xl border border-white/20 shadow-2xl transform transition-transform duration-1000 group-hover:rotate-1">
                    <img
                      src={what_we_do}
                      alt="what we do"
                      className="w-full h-auto rounded-[2.5rem] shadow-inner grayscale-[20%] group-hover:grayscale-0 transition-all duration-700"
                    />

                  </div>
                  <div className="absolute -top-12 -left-12 w-24 h-24 border-t-2 border-l-2 border-blue-500/30 rounded-tl-3xl" />
                  <div className="absolute -bottom-12 -right-12 w-24 h-24 border-b-2 border-r-2 border-indigo-500/30 rounded-br-3xl" />
                </div>
              </div>
              <div className="lg:col-span-7 space-y-10">
                <div className="space-y-6">
                  <h2 className="text-5xl md:text-7xl font-black text-[#000856] leading-[1.05] font-spacegrotesk tracking-tight">
                    What We <span className="text-transparent bg-clip-text bg-gradient-to-br from-blue-400 via-indigo-300 to-pink-400">Do</span>
                  </h2>

                  <p className="text-[#000856] text-lg md:text-2xl leading-relaxed font-light max-w-2xl">
                    We are a tech-driven group that aims to promote social and financial inclusion through several banks . Bumppy Payments, which is based on the main tenet of "Pay in seconds," provides simple and clever solutions through its top-notch electronic transaction processing system, allowing customers to conduct transactions at our retail locations in a matter of seconds.
                  </p>
                </div>
                <div className="relative pl-8 border-l-2 border-indigo-500/50">
                  <p className="text-xl md:text-2xl text-[#000856] font-medium italic leading-snug">
                    "Empowering 100 million+ rural users through seamless digital connectivity and financial inclusion."
                  </p>

                </div>
              </div>
            </div>
          </div>
        </section>

       

        <section className="relative w-full py-24 lg:py-36 bg-gradient-to-bl from-[#041294] to-[#000856] overflow-hidden">


          <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-blue-600/10 blur-[120px] rounded-full" />
          <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-indigo-600/10 blur-[100px] rounded-full" />

          <div className="max-w-7xl mx-auto px-6 relative z-10">
            <div className="grid lg:grid-cols-12 gap-16 items-center">

              <div className="lg:col-span-7 space-y-10">



                <div className="space-y-6">
                  <h2 className="text-5xl md:text-7xl font-black text-white leading-[1.05] font-spacegrotesk tracking-tight">
                    Our <span className="text-transparent bg-clip-text bg-gradient-to-br from-blue-400 via-indigo-300 to-pink-400">Vision</span>
                  </h2>

                  <p className="text-slate-400 text-lg md:text-2xl leading-relaxed font-light max-w-2xl">
                    Our Actual goal is to outperform our current position in the industry and lead the list of software companies in India. We assist our clients in achieving their business goals since we believe that their success is also a reflection of our own.
                  </p>
                </div>



              
                <div className="relative pl-8 border-l-2 border-indigo-500/50">
                  <p className="text-xl md:text-2xl text-indigo-100 font-medium italic leading-snug">
                    "Providing rural Indians with simple access to last-mile banking services and other financial goods."
                  </p>

                </div>
              </div>

              
              <div className="lg:col-span-5 relative">
                <div className="relative z-20 group">
                  
                  <div className="relative rounded-[3rem] p-3 bg-gradient-to-b from-white/10 to-transparent backdrop-blur-2xl border border-white/20 shadow-2xl transform transition-transform duration-1000 group-hover:rotate-1">
                    <img
                      src={vision}
                      alt="Bumppy Vision"
                      className="w-full h-auto rounded-[2.5rem] shadow-inner grayscale-[20%] group-hover:grayscale-0 transition-all duration-700"
                    />

                  </div>


                  <div className="absolute -top-12 -left-12 w-24 h-24 border-t-2 border-l-2 border-blue-500/30 rounded-tl-3xl" />
                  <div className="absolute -bottom-12 -right-12 w-24 h-24 border-b-2 border-r-2 border-indigo-500/30 rounded-br-3xl" />
                </div>
              </div>

            </div>
          </div>
        </section>
  

        <section className="py-20 bg-white relative overflow-hidden">
          
          <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
            style={{ backgroundImage: 'radial-gradient(#000 1px, transparent 1px)', backgroundSize: '30px 30px' }} />

          <div className="max-w-7xl mx-auto px-6 relative z-10">

            
            <header className="text-center max-w-3xl mx-auto mb-20">
              

              <h2 className="font-spacegrotesk text-slate-900 text-3xl sm:text-4xl md:text-5xl font-bold leading-tight">
                Our Trusted <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">Partners</span>
              </h2>

              <div className="w-20 h-1.5 bg-pink-500 mx-auto mt-6 rounded-full" />

              <p className='text-slate-500 text-lg md:text-xl font-medium mt-6 leading-relaxed'>
                Celebrate a lifetime of seamless payment experiences with our industry-leading banking and technology partners.
              </p>
            </header>

            
            <div className="mx-auto max-w-5xl grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8 items-center">
             
              {partner.map((item, idx) => (
                <div
                  key={idx}
                  className="group relative flex items-center justify-center h-28 md:h-32  px-6 rounded-2xl bg-slate-50 border border-slate-100 transition-all duration-500 hover:bg-white hover:shadow-2xl hover:shadow-blue-900/10 hover:-translate-y-2"
                >
                  
                  <div className="w-full h-15  animate-pulse group-hover:animate-none group-hover:bg-transparent flex items-center justify-center">
                    <span className="text-slate-400 group-hover:text-blue-600 font-bold tracking-tighter transition-colors">
                      <img src={item.img} alt="" className=' w-full object-fit' />
                    </span>
                  </div>

                  
                  {/* <div className="absolute inset-x-10 bottom-0 h-1 bg-gradient-to-r from-transparent via-blue-500 to-transparent scale-x-0 group-hover:scale-x-100 transition-transform duration-500" /> */}
                </div>
              ))}
            </div>

            
            
          </div>
        </section>


      
      </section>
      <CtaSection/>
    </div>
  )
}
